// nivo's sankey link gradients write each node id verbatim into the SVG
// <linearGradient id="..."> but reference it URL-encoded
// (fill='url("#Scope%202...")'). Chrome resolves the mismatch, Safari does
// not — links render with no fill at all. Re-keying nodes to slug ids (n0,
// n1, ...) keeps the two forms identical so gradients work everywhere; the
// human-readable name is carried in the returned labels map for nivo's
// `label` accessor and the tooltips.
export const toSafariSafeSankey = (nodes, links, displayLabel = (id) => id) => {
  const idMap = new Map();
  const labels = new Map();
  const safeNodes = (nodes || []).map((node, i) => {
    const safeId = `n${i}`;
    idMap.set(node.id, safeId);
    labels.set(safeId, displayLabel(node.id));
    // origId preserved for callers that key logic off the original id
    // (e.g. counting left-column "A:" nodes for chart height).
    return { ...node, id: safeId, origId: node.id };
  });
  const safeLinks = (links || []).map((link) => ({
    ...link,
    source: idMap.get(link.source),
    target: idMap.get(link.target),
  }));
  return { nodes: safeNodes, links: safeLinks, labels };
};
